import { myChangeDetail } from "@/apis/user";
import { Toast } from "antd-mobile";
import { useCallback, useEffect, useRef,useState } from "react";
import { useParams } from "react-router-dom";
import { FormInstance } from "antd-mobile/es/components/form";

export const useLogic = ()=> {
  const {orderId} = useParams();
  const [loading, setLoading] = useState<boolean>(true);
  const formRef = useRef<FormInstance>();
  const onFormRef = useCallback((form: FormInstance) =>{
    formRef.current = form;
  },[])

  useEffect(() => {
    const timer = setInterval(() => {
      if(formRef.current ){
        clearInterval(timer);
        fetchOrderDetail();
      }
    }, 200)
  }, [])

  const fetchOrderDetail = async () => {
    const { ok, data, msg } = await myChangeDetail({ id:orderId as string});
      if (ok) {

        formRef.current?.setFieldsValue({
          createTime: data.list.createTime || "",
          typeName: data.list.typeName ||"",
          amount: data.list.amount ||"",
          receiverNickName: data.list.receiverNickName ||"",
          payNickName: data.list.payNickName ||"",
          businessNo: data.list.businessNo ||"",
        })
        setLoading(false);
      } else {
        Toast.show(msg);
      }
  }

  return {
    onFormRef, 
    loading
  }
}